import React, {Component} from 'react';
import {Button, List} from 'semantic-ui-react';
import connect from "react-redux/es/connect/connect";
import TicketData from "../../data/TicketData";
import {ticketDialog} from "../../actions/TicketDialogActions";
import {showToast} from "../../actions/ToastAction";
import {selectTicket} from "../../actions/TicketSelectActions";
import {dynamicTableAddOrUpdate} from "../../actions/DynamicTableDataAction";

class TicketItem extends Component {
    constructor(props){
        super(props);
        this.state = {
            delete_loading:false,
            add_loading: false,
            remove_loading: false,
            quantity: props.quantity,
            delete: false
        };
    }

    handleDelete = () => {
        let quantity = this.state.quantity-1;
        if(quantity >= 1){
            this.setState({delete_loading:true});
            this.update({
                id:this.props.id,
                quantity
            });
        }
    };

    handleRemove = () => {
        this.remove();
    };

    async remove() {
        TicketData.productDelete(this.props.id, (res) => {
            this.setState({add_loading:false, delete_loading:false});
            if (res === null) {
                let ticket = this.props.ticket_select;
                let products = this.props.ticket_select.products.slice();
                ticket.products = products.filter(product => product.id !== this.props.id);
                this.setState({delete:true});
                this.handleDispatch(ticket);
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
        });
    };

    handleDispatch = (ticket) =>{
        this.props.selectTicket(ticket);
        this.props.dynamicTableAddOrUpdate(ticket);
    };

    handleAdd = () => {
        let quantity = this.state.quantity+1;
        if(quantity >= 1){
            this.setState({add_loading:true});
            this.update({
                id:this.props.id,
                product: this.props.product.id,
                quantity
            });
        }
    };

    handleDelete = () => {
        let quantity =this.state.quantity-1;
        if(quantity >= 1){
            this.setState({delete_loading:true});
            this.update({
                id:this.props.id,
                product: this.props.product.id,
                quantity,
            });
        }
    };

    async update(data) {
        TicketData.productUpdate(data, (res) => {
            if (res.update) {
                let ticket = this.props.ticket_select;
                ticket.products = this.props.ticket_select.products.map(product =>{
                    if(product.id === res.data.id){
                        product.quantity = res.data.quantity;
                        this.setState({quantity: product.quantity});
                        return product;
                    }else {
                        return product;
                    }
                });
                this.handleDispatch(ticket);
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
            this.setState({add_loading:false, delete_loading:false});
        });
    };

    render() {
        if(!this.state.delete){
            return (
                <List.Item>
                    <List.Content floated='left'>
                        <Button.Group size='small'>
                            <Button
                                icon='minus'
                                onClick={this.handleDelete}
                                loading={this.state.delete_loading}
                                disabled={this.state.delete_loading}/>
                            <Button content={this.state.quantity} active />
                            <Button
                                icon='plus'
                                onClick={this.handleAdd}
                                loading={this.state.add_loading}
                                disabled={this.state.add_loading}/>
                        </Button.Group>
                    </List.Content>
                    <List.Content floated='right'>
                        <Button.Group size='small' color='orange'>
                            <Button
                                icon='trash'
                                onClick={this.handleRemove}
                                loading={this.state.remove_loading}
                                disabled={this.state.remove_loading}/>
                        </Button.Group>
                    </List.Content>
                    <List.Content style={{paddingTop:10}}>{this.props.product.name}</List.Content>
                </List.Item>
            );
        }else{
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        ticket_select: state.get('ticket_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ticketDialog(data) {
            dispatch(ticketDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectTicket(data){
            dispatch(selectTicket(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketItem);


// WEBPACK FOOTER //
// ./src/components/services/TicketItem.js